const infinity = {
    infinity: {
        test (x) { return x === Number.POSITIVE_INFINITY; },
        replace (n) { return 'Infinity'; },
        revive (s) { return Number.POSITIVE_INFINITY; }
    }
};

export default infinity;
